import { Injectable } from '@angular/core';
import { of } from 'rxjs';
import { catchError, map, take } from 'rxjs/operators';
import { CookieKey } from '@lib/cookie-keys.const';
import { getCookie, setCookie } from '@lib/cookies';
import { extractResponseBody } from '@lib/utils';
import { ServerApi, W3_API } from '@services/server-api';
import { getSendBirdAppId } from '@lib/environments.const';
import { logger } from '@lib/datadog';
import * as i0 from "@angular/core";
import * as i1 from "@services/server-api";
export class SendbirdTokenService {
    constructor(api) {
        this.api = api;
    }
    fetchAuthToken() {
        // Check if we already have a token in cookies
        const existingToken = getCookie(CookieKey.SENDBIRD_AUTH_TOKEN);
        if (existingToken) {
            return of(existingToken);
        }
        // If no token exists, fetch a new one from the API
        return this.api.post('messages/sessions', {
            sendbird_app_id: getSendBirdAppId(),
        }, new Map(), W3_API)
            .pipe(map(extractResponseBody), take(1), map((res) => {
            if (!res || !res.data || !res.data.token) {
                throw new Error('Invalid response from messages/sessions API');
            }
            const sendBirdAuthData = res.data;
            if (sendBirdAuthData.expires_at) {
                // Convert milliseconds to days (milliseconds / (1000 * 60 * 60 * 24))
                const expiresInDays = Math.ceil((sendBirdAuthData.expires_at - Date.now()) / (1000 * 60 * 60 * 24));
                setCookie(CookieKey.SENDBIRD_AUTH_TOKEN, sendBirdAuthData.token, { expires: expiresInDays });
            }
            else {
                setCookie(CookieKey.SENDBIRD_AUTH_TOKEN, sendBirdAuthData.token);
            }
            return sendBirdAuthData.token;
        }), catchError(error => {
            logger.error(error);
            throw new Error('Failed to fetch SendBird authentication token: ' + error);
        }));
    }
}
SendbirdTokenService.ɵfac = function SendbirdTokenService_Factory(t) { return new (t || SendbirdTokenService)(i0.ɵɵinject(i1.ServerApi)); };
SendbirdTokenService.ɵprov = i0.ɵɵdefineInjectable({ token: SendbirdTokenService, factory: SendbirdTokenService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SendbirdTokenService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: i1.ServerApi }]; }, null); })();
